export class UpdateEmployee {
    employeeId: number|undefined;
    matricule : string;
    initiale : string;
    poste : string;
    lastname : string;
    firstname : string;
    mobilePhone : string;
    businessEmail : string;
    businessPhone : string;
    photo : string;
    photoContentType : string;
    codeAgent: string;
    departementId: string;
  }